<section>
  <div class="pad">
    <table mat-table [dataSource]="dataSource" class="sMbdrRad mat-elevation-z8">
      <ng-container matColumnDef="claim_number">
        <th mat-header-cell *matHeaderCellDef>Claim Number</th>
        <td mat-cell *matCellDef="let element">{{ element.claim_number }}</td>
      </ng-container>

      <ng-container matColumnDef="policy_number">
        <th mat-header-cell *matHeaderCellDef>Policy Number</th>
        <td mat-cell *matCellDef="let element">
          {{ element.policy_number}}
        </td>
      </ng-container>
      
      <ng-container matColumnDef="incident_location">
        <th mat-header-cell *matHeaderCellDef class="incident_location">Incident Location</th>
        <td mat-cell *matCellDef="let element" class="incident_location">
          {{ element.incident_location }}
        </td>
      </ng-container>

      <ng-container matColumnDef="incident_date">
        <th mat-header-cell *matHeaderCellDef class="gross">Incident Date</th>
        <td mat-cell *matCellDef="let element" class="gross">
          {{ element.incident_date | date }}
        </td>
      </ng-container>

      <ng-container matColumnDef="destination">
        <th mat-header-cell *matHeaderCellDef>Destination</th>
        <td mat-cell *matCellDef="let element">
          {{ element.destination}}
        </td>
      </ng-container>

      <ng-container matColumnDef="gross_premium">
        <th mat-header-cell *matHeaderCellDef>Gross Premium</th>
        <td mat-cell *matCellDef="let element">
          {{ element.gross_premium | currency : "₦ " }}
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef class="status">Status</th>
        <td mat-cell *matCellDef="let element" class [ngStyle]="{'color': element.status === 'accepted' ? '#2ecc71' : element.status === 'rejected' ? '#f8051f' : (element.status === 'queried' ? '#f8c805' : 'inherit')}">
            {{ element.status | titlecase }}
          </td>
      </ng-container>

      <ng-container matColumnDef="view">
        <th mat-header-cell *matHeaderCellDef>View</th>
        <td mat-cell *matCellDef="let element">
         <button class="button" (click)="viewClaimDetails(element)">View</button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
    <div *ngIf="non" class="non">No Claim Yet</div>
    
  </div>
</section>
